import { useCallback , useEffect} from "react";
import { useMasterData } from '../context/MasterDataContext';
import { isKelasPutra, isKelasPutri } from '../utils/jenjangUtils';

export const useGenderKelas = () => {
    const { kelasRecords , fetchKelasData} = useMasterData();

    useEffect(() => {
        fetchKelasData();
    }, [fetchKelasData]);


    const checkIsKelasPutra = useCallback((className: string) => {
        return isKelasPutra(className, kelasRecords);
    }, [kelasRecords]);

    const checkIsKelasPutri = useCallback((className: string) => {
        return isKelasPutri(className, kelasRecords);
    }, [kelasRecords]);

    return {
        checkIsKelasPutra,
        checkIsKelasPutri
    };
};
